(ns manage.adset-decision-tree-page.editor.util
  (:require [cljs-bean.core :refer [->clj ->js]]
            [clojure.string :as str]
            [manage.adset-decision-tree-page.view.node-conversion :as node-conversion]))

(defn assoc-reactflow-object [^js js-object k v]
  (let [o (->clj js-object)]
    (cond
      (= (get o k) v) js-object
      v (->js (assoc o k v))
      (not v) (->js (dissoc o k)))))

(defn assoc-reactflow-objects-for-ids [js-object-map ids k v]
  (reduce
   (fn [js-object-map edge-id]
     (update js-object-map edge-id assoc-reactflow-object k v))
   js-object-map
   ids))

(defn get-node-ascendants [node-id->node-data node-id]
  (loop [node-id node-id
         ascendants {:outcome-node-ids '()
                     :edge-ids '()
                     :nodes '()}]
    (if-let [{:keys [category parent-id] :as node} (get node-id->node-data node-id)]
      (let [ascendants (update ascendants :nodes conj node)]
        (case category
          :decision-node (recur parent-id (update ascendants :edge-ids
                                                  conj (node-conversion/->edge parent-id
                                                                               node-id)))
          :outcome-node (recur parent-id (update ascendants :outcome-node-ids conj node-id))
          ascendants))
      ascendants)))

(defn build-decision-path [node-id->node-data node-id]
  (cond->> (:nodes (get-node-ascendants node-id->node-data node-id))
    true (mapv (fn [n]
                 (case (:category n)
                   :root-node "Starting Point"
                   :decision-node (:name n)
                   :outcome-node (:label n)
                   nil)))
    (#{:root-node :decision-node} (get-in node-id->node-data [node-id :category]))
    (#(conj % "Default"))
    true (str/join " / ")))

(defn get-outcome-descendants [node-id->children outcome-node]
  (let [outcome-node-id (:id outcome-node)
        child-id (some-> outcome-node-id
                         node-id->children
                         first
                         :id)]
    {:decision-node-id child-id
     :edge-id (some->> child-id (node-conversion/->edge outcome-node-id))}))
